export type LocaleFileNameResolverDelegate =
  /**
   * Resolves a file name for a given `locale`.
   *
   * @param locale The locale to resolve the file name for.
   * @returns The resolved path for the given locale.
   */
  (locale: string) => string;
